<template>
	<b-modal
		ref="mymodal1"
		id="draganddrop"
		size="lg"
		centered
		hide-footer
		hide-header
		:backdrop-class="computedBackdropClass"
		no-close-on-backdrop
		v-model="showModalss"
		@hidden="handleModalHidden"
		modal-class="draganddrop"
	>
		<div id="hideinmobile" class="w-100">
			<!-- <div
              v-if="progressPercentage < 5"
              @click="stopWatchingCandidateInfo(), openFillFormModal()"
              class="d-flex justify-content-end pointer pt-3 pr-3"
            >
              <img
                class="rotate-on-hover"
                src="@/assets/newdesign/dashboard/blueCross.svg"
                alt=""
              />
            </div> -->

			<div v-if="progressPercentage < 5" class="candash-modal-body-10 w-100">
				<section class="d-flex left-cont-padding h-100">
					<section class="w-60">
						<div style="height: 300px">
							<div class="fam-mont fw-M fs-16 text-8cgrey">PROFILE SETUP</div>
							<div class="fam-mont fs-18 fw-B color-2E425D mt-16px">
								Upload Existing Resume
							</div>
							<div class="fam-lato fs-16 fw-LM color-3a3c40 mt-16px">
								Enable us to autofill your profile
							</div>
							<div class="mt-16px">
								<img
									src="../../assets/img/uploadresume/uploadresumemain.svg"
									alt=""
									class="laptopuploadimagesize"
								/>
							</div>
						</div>
						<hr style="border-top: 1px solid; opacity: 13%" class="mr-3" />

						<div class="d-flex align-items-center gap-3">
							<b-button
								class="onboard-back-btn w-152px"
								v-if="showBackToOnboarding && progressPercentage < 5"
								@click="handleBackToOnboarding"
							>
								Back
							</b-button>
							<b-button
								@click="$emit('getCandidateDetail'), $emit('open-fill-form')"
								class="candash-customBtn w-152px"
								:disabled="progressPercentage < 100"
								>Get Started</b-button
							>
						</div>
					</section>
					<div class="vertical-dashed mb-4"></div>
					<section
						@drop="handleDrop"
						@dragover.prevent="handleDragOver"
						class="dragdrop-area mb-4 mx-4 p-3 d-flex flex-column align-items-center justify-content-center w-40"
					>
						<img src="../../assets/img/uploadresume/uploadicon.svg" alt="" />
						<div
							class="d-flex flex-column align-items-center justify-content-center mt-24px"
						>
							<div class="color-3a3c40 fs-16 fw-B fam-lato">
								Drag and drop your resume here
							</div>
							<p class="color-828BA2 fam-lato fw-LM fs-14">
								(.pdf, .doc. docx) max 5 mb
							</p>
						</div>
						<div class="position-relative ucdSelDocFile">
							<b-form-file
								@change="selectResume"
								accept=".pdf , .docx, .doc,"
								placeholder=""
								id="uploadcandimage"
								ref="files"
							>
							</b-form-file>
							<b-button class="candash-customBtn mt-24px">
								<img
									src="../../assets/img/uploadresume/btnuploadicon.svg"
									alt=""
									class="mr-2"
								/>
								Browse your resume</b-button
							>
						</div>
						<div
							v-if="!showBackToOnboarding"
							class="my-3 w-100 position-relative"
						>
							<hr class="w-100" style="border-top: 1px solid; opacity: 13%" />
							<span class="fam-mont position-absolute ortxt">or</span>
						</div>
						<div
							v-if="!showBackToOnboarding"
							@click="stopWatchingCandidateInfo(), $emit('open-fill-form')"
							class="d-flex align-items-center fam-mont fw-M fs-13 text-blue pointer"
						>
							<img
								src="../../assets/img/uploadresume/createresume.svg"
								alt=""
								class="mr-2"
							/>
							Create a new resume
						</div>
					</section>
				</section>
				<!-- <div class="pl-5 d-flex flex-column justify-content-between h-100 pt-1">
					<div class="mt-4">
						<img src="@/assets/newdesign/dashboard/dndModal.svg" alt="" />
					</div>
					<div>
						<div class="candash-boldtxt-2">
							Prepare to apply for your Dream Job!
						</div>
						<div class="candash-light-txt-2 mt-1">Fastrack your career</div>
					</div>
					<div class="candash-squareBtn ucdSelDocFile position-relative mt-3">
						<b-form-file
							@change="selectResume"
							accept=".pdf , .docx, .doc,"
							placeholder=""
							id="uploadcandimage"
							ref="files"
						>
						</b-form-file>

						<img
							class="mr-2 mt-2 mb-2"
							src="@/assets/newdesign/dashboard/whiteUpload.svg"
							alt="upload button"
						/>

						<span>Browse your resume</span>
					</div>
					<div class="mb-4 d-flex align-items-center gap-3">
						<b-button
							v-if="!showBackToOnboarding"
							@click="stopWatchingCandidateInfo(), $emit('open-fill-form')"
							class="candash-cancelBtn pointer"
							>Create New</b-button
						>
						<b-button
							v-else-if="progressPercentage < 5"
							@click="handleBackToOnboarding"
							class="upload-inline-back-btn"
						>
							Back
						</b-button>
					</div>
				</div> -->
				<!-- <div v-if="pdfPreview" class="pr-5">
                <embed
                  :src="pdfPreview"
                  type="application/pdf"
                  width="100%"
                  height="500px"
                />
              </div> -->
				<!-- <div class="pr-5" @drop="handleDrop" @dragover.prevent="handleDragOver">
					<img
						src="@/assets/newdesign/dashboard/dragAndDrop.svg"
						alt="Drop your resume"
					/>
				</div> -->
			</div>

			<!-- After Uploading -->
			<div
				v-if="progressPercentage > 5 && progressPercentage < 101"
				class="candash-modal-body-10 d-flex align-items-center justify-content-between padding24px"
			>
				<div class="pr-4 d-flex flex-column h-100 justify-content-between">
					<div>
						<div
							v-if="progressPercentage < 100"
							class="candash-boldtxt-2 d-flex align-items-center"
						>
							We are uploading your resume...
						</div>
						<div
							v-if="progressPercentage == 100"
							class="d-flex align-items-center fam-lato fs-27 fw-LM color-038E00"
						>
							<img
								class="mr-1"
								src="@/assets/img/uploadresume/greentick.svg"
								alt=""
							/>
							Your resume is uploaded successfully
						</div>
						<div
							v-if="progressPercentage < 100"
							class="fam-lato fs-16 fw-R color-7a7a7a mt-16px"
						>
							We're in the process of uploading your resume, structuring your
							details, and seamlessly integrating them into our template.
						</div>
						<div
							v-if="progressPercentage == 100"
							class="fam-lato fs-16 fw-R color-7a7a7a mt-16px"
						>
							Please click on Get Started to continue building your profile.
						</div>
						<div class="mt-24px">
							<div class="candash-modal-label-2">Please Ensure that</div>
							<div class="d-flex align-items-start mt-2">
								<div class="d-flex flex-column align-items-center p10">
									<div class="loader-blue-dot"></div>
								</div>
								<div class="ml-3 candash-light-txt-2">
									Ensure to Review and edit each section as highlighted.
								</div>
							</div>
							<div class="d-flex mt-2">
								<div class="d-flex flex-column align-items-center p8">
									<div class="loader-blue-dot"></div>
								</div>
								<div class="ml-3 candash-light-txt-2">
									Save or Download your resume on completion of the review
								</div>
							</div>
						</div>
					</div>
					<section>
						<hr style="border-top: 1px solid; opacity: 13%" />
						<div class="d-flex align-items-center gap-3">
							<b-button
								v-if="showBackToOnboarding && progressPercentage < 5"
								class="onboard-back-btn w-152px"
								@click="handleBackToOnboarding"
							>
								Back
							</b-button>

							<b-button
								@click="$emit('getCandidateDetail'), $emit('open-fill-form')"
								:disabled="progressPercentage < 100"
								class="candash-customBtn w-152px"
								>Get Started</b-button
							>
						</div>
					</section>
				</div>

				<div class="position-relative d-flex justify-content-center h-100">
					<div
						class="after-upload-box position-relative h-100"
						:class="{
							'uploading-state':
								progressPercentage > 5 && progressPercentage < 100,
							'uploaded-state': progressPercentage === 100,
						}"
					>
						<div
							v-if="progressPercentage === 100"
							class="after-upload-box-footer d-flex align-items-center justify-content-between position-absolute bottom-0 left-0 w-100 px-3"
						>
							<div
								class="d-flex align-items-center flex-grow-1 min-width-0"
								style="min-width: 0"
							>
								<img
									src="../../assets/img/uploadresume/resumegreenicon.svg"
									alt=""
								/>
								<div
									class="color-3a3c40 fw-B fam-lato fs-15 text-truncate ml-2"
									style="max-width: 155px"
								>
									{{ resumeForParser.name }}
								</div>
							</div>
							<div class="d-flex align-items-center gap-2">
								<div class="ucdSelDocFile position-relative">
									<img src="../../assets/img/uploadresume/replace.svg" alt="" />
									<b-form-file
										@change="exchange"
										accept=".pdf , .docx, .doc,"
										placeholder=""
										id="uploadcandimage"
										ref="files"
									>
									</b-form-file>
								</div>
								<img src="../../assets/img/uploadresume/line.svg" alt="" />
								<img
									src="../../assets/img/uploadresume/delete.svg"
									@click="cancelUploadParser()"
									class="pointer"
									alt=""
								/>
							</div>
						</div>
					</div>

					<div class="comunicatn-tst-timer mt-5" style="z-index: 5">
						<div
							class="position-relative p-3 height-85per d-flex flex-column justify-content-center align-content-center"
						>
							<div
								class="progress-timer d-flex justify-content-center align-items-center"
							>
								<div class="circle-loader">
									<svg width="160" height="160" class="progress-ring">
										<!-- Outer solid ring -->
										<circle class="outer-ring" cx="80" cy="80" r="68" />

										<!-- Always visible dashed ring -->
										<circle class="dashed-ring" cx="80" cy="80" r="58" />

										<!-- Progress ring -->
										<circle
											class="progress-ring-fill"
											cx="80"
											cy="80"
											r="68"
											:stroke-dasharray="427"
											:stroke-dashoffset="
												427 - (progressPercentage / 100) * 427
											"
										/>
									</svg>

									<!-- Center text -->
									<div class="progress-text">{{ progressPercentage }}%</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="fw-M fam-lato fs-20 text-blue uploadingtxt"
						v-if="progressPercentage < 100"
					>
						Uploading ...
					</div>

					<div
						v-if="progressPercentage == 100"
						@click="cancelUploadParser()"
						class="d-flex align-items-center rubox-cancel-btn mt-5 pointer"
					>
						<img
							class="rubbox-nothovered mr-2 h11w9"
							src="@/assets/img/xcancel.svg"
							alt=""
						/>
						<img
							class="rubox-hovered mr-2 h11w9"
							src="@/assets/img/hoverxcancel.svg"
							alt=""
						/>
						Cancel
					</div>
				</div>
			</div>
		</div>
		<div id="hideinlaptop" class="d-flex flex-column position-relative">
			<!-- Header -->
			<header
				class="p-3 setup-header d-flex align-items-baseline justify-content-between"
			>
				<div class="">
					<p class="fam-mont fw-M fs-16 text-8cgrey mb-1">PROFILE SETUP</p>
					<h2 class="color-2E425D fam-mont fs-18 fw-B">
						Upload Existing Resume
					</h2>
				</div>
				<!-- <img
					src="@/assets/newdesign/resumeclinic/mobileclose.svg"
					class="mobilecloseicon pointer rotate-on-hover"
					alt=""
				/> -->
			</header>
			<template>
				<section
					class="p-3 d-flex align-items-center justify-content-center flex-column mobile-main-content-screen gap-5"
				>
					<template v-if="progressPercentage > 5 && progressPercentage < 100">
						<div
							style="height: 330px !important"
							class="after-upload-box position-relative h-100"
							:class="{
								'uploading-state':
									progressPercentage > 5 && progressPercentage < 100,
								'uploaded-state': progressPercentage === 100,
							}"
						>
							<div style="z-index: 5">
								<div
									class="position-relative p-3 height-85per d-flex flex-column justify-content-center align-content-center"
								>
									<div class="d-flex justify-content-center align-items-center">
										<div class="circle-loader">
											<svg width="200" height="200" class="progress-ring">
												<!-- Outer solid ring -->
												<circle class="outer-ring" cx="96" cy="96" r="90" />

												<!-- Always visible dashed ring -->
												<circle class="dashed-ring" cx="96" cy="96" r="80" />

												<!-- Progress ring -->
												<circle
													class="progress-ring-fill"
													cx="96"
													cy="96"
													r="90"
													:stroke-dasharray="565"
													:stroke-dashoffset="
														565 - (progressPercentage / 100) * 565
													"
												/>
											</svg>

											<!-- Center text -->
											<div class="progress-text">{{ progressPercentage }}%</div>
										</div>
									</div>
								</div>
							</div>
							<div
								class="fw-M fam-lato fs-20 text-blue uploadingtxt"
								v-if="progressPercentage < 100"
							>
								Uploading ...
							</div>
						</div>

						<section class="mt-2">
							<div class="text-blue fam-mont fs-14 fw-M">
								Please Ensure that:
							</div>
							<div class="d-flex gap-1 align-items-start">
								<img src="../../assets/img/uploadresume/pointsmob.svg" alt="" />
								<div class="color-595959 fs-16 fam-lato fw-LM">
									Ensure to Review and edit each section as highlighted.
								</div>
							</div>
							<div class="d-flex gap-1 mt-2 align-items-start">
								<img src="../../assets/img/uploadresume/pointsmob.svg" alt="" />
								<div class="color-595959 fs-16 fam-lato fw-LM">
									Save or Download your resume on completion of the review
								</div>
							</div>
						</section>
					</template>
					<template v-else>
						<img alt="" src="@/assets/img/uploadresume/mobmainimage.svg" />
						<template v-if="progressPercentage < 5">
							<div
								class="mobile-upload-res ucdSelDocFile position-relative d-flex align-items-center justify-content-between w-100 px-3 dragdrop-area"
							>
								<div>
									<div class="fs-15 fw-B fam-lato color-3a3c40">
										Upload File
									</div>
									<div class="mobjd-light-txt mt-1">
										(.pdf, .doc. docx) max 5 mb
									</div>
								</div>
								<div class="d-flex align-items-center">
									<div class="asp-vertical-line mr-2"></div>
									<div>
										<img
											src="../../assets/newdesign/jdprogress/mobjdprog/upload.svg"
											alt=""
										/>
									</div>
								</div>
								<b-form-file
									@change="selectResume"
									accept=".pdf , .docx, .doc,"
									placeholder=""
									id="uploadcandimage"
									ref="files"
								>
								</b-form-file>
							</div>

							<div
								v-if="!showBackToOnboarding"
								@click="stopWatchingCandidateInfo(), $emit('open-fill-form')"
								class="d-flex align-items-center fam-mont fw-M fs-13 text-blue pointer"
							>
								<img
									src="../../assets/img/uploadresume/createresume.svg"
									alt=""
									class="mr-2"
								/>
								Create a new resume
							</div>
						</template>
						<div
							v-else-if="progressPercentage == 100"
							class="mobile-uploaded-res d-flex align-items-center justify-content-between w-100 px-3 position-relative dragdrop-uploaded"
						>
							<div class="d-flex align-items-center w-75">
								<div>
									<img src="../../assets/img/uploadresume/mobuploaded.svg" />
								</div>
								<div class="asp-small-grey-txt-2 ml-1 w-75 text-truncate">
									{{ resumeForParser.name }}
								</div>
							</div>
							<div
								class="d-flex justify-content-between h-100 align-items-center gap-2"
							>
								<div
									class="ucdSelDocFile position-relative d-flex align-items-center justify-content-between w-100 px-2"
								>
									<img
										src="../../assets/icons/mobUpldDoc/replace_mob.svg"
										alt=""
										class="pointer"
									/>
									<b-form-file
										@change="exchange"
										accept=".pdf , .docx, .doc,"
										placeholder=""
										id="uploadcandimage"
										ref="files"
									>
									</b-form-file>
								</div>

								<div class="asp-vertical-line"></div>

								<img
									@click="cancelUploadParser()"
									src="../../assets/icons/mobUpldDoc/delete-mob.svg"
									alt=""
									class="pointer"
								/>
							</div>
						</div>
					</template>
				</section>
			</template>
			<hr style="border-top: 1px solid" />
			<section class="px-3 pb-3 d-flex align-items-center gap-3">
				<!-- -->
				<b-button
					v-if="showBackToOnboarding && progressPercentage < 5"
					@click="handleBackToOnboarding"
					class="onboard-back-btn w-50"
					style="height: 40px"
				>
					Back
				</b-button>
				<b-button
					@click="$emit('getCandidateDetail'), $emit('open-fill-form')"
					:disabled="progressPercentage < 100"
					class="tabs-custom-btn"
					:class="{
						'w-50': showBackToOnboarding && progressPercentage < 5,
						'w-100': !(showBackToOnboarding && progressPercentage < 5),
					}"
					>Get Started</b-button
				>
			</section>
			<!-- <div
				class="tabs-upload-haze p-4"
				v-if="progressPercentage > 5 && progressPercentage < 100"
			>
				<div class="comunicatn-tst-timer mt-3">
					<div
						class="position-relative p-3 h-100 w-100 d-flex flex-column justify-content-center align-content-center"
					>
						<div
							class="progress-timer d-flex justify-content-center align-items-center"
						>
							<div
								class="typingtest-progress-container"
								ref="progressContainerMob"
							>
								<div class="typingtest-valueprogress">
									<div class="time-txt">
										{{ progressPercentage }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="fam-lato fs-16 fw-LM text-white d-flex flex-column gap-3 tabs-pt-155"
				>
					<span>Please Ensure that:</span>
					<div class="d-flex align-items-center gap-3">
						<div class="tabs-blue-dot"></div>
						<div>Ensure to Review and edit each section as highlighted.</div>
					</div>
					<div class="d-flex align-items-center gap-3">
						<div class="tabs-blue-dot"></div>
						<div>Save or Download your resume on completion of the review</div>
					</div>
				</div>
			</div> -->
		</div>
	</b-modal>
</template>

<script>
import { mapGetters } from "vuex";

import { postCandParser, cancelUpload } from "@/utils/apiFunctions";
import { trackResumeUploaded } from '@/utils/posthogHelpers';
import toast from "../mixin/toast";
export default {
	name: "UploadResume",
	data() {
		return {
			progressPercentage: 0,
			candidateInfoWatcher: null,
			uploadResume: false,
			resumeForParser: null,
			showModalss: this.showModal,
		};
	},
	props: {
		showModal: Boolean,
		isLaptop: Boolean,
		showBackToOnboarding: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		computedBackdropClass() {
			return this.isOnboardingActive ? "onboarding-modal-backdrop" : "";
		},
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
			getCandPrimaryProgInfo: "getCandProgressRespPrimary",
			isOnboardingActive: "getIsOnboardingActive",
			getCandPrimaryInfo: "getPrimaryCandidateInfo"
		}),
	},
	mixins: [toast],
	mounted() {
		if (this.showModal) {
			this.$nextTick(() => {
				this.$refs.mymodal1.show();
			});
		}
	},
	watch: {
		showModal(val) {
			this.$store.commit("candidateVUEX/setOnboardingActive", val);
			if (val) {
				this.$refs.mymodal1.show();
			} else {
				this.$refs.mymodal1.hide();
			}
		},
	},
	methods: {
		handleModalHidden() {
			this.showModalss = false;
			this.$emit("upload-modal-closed");
		},
		handleBackToOnboarding() {
			this.stopWatchingCandidateInfo();
			this.$emit("back-to-onboarding");
		},
		async exchange(event) {
			this.selectResume(event, true);
		},
		async selectResume(event, cancelFunc = false) {
			const input = event.target;
			const files = input.files;

			if (files.length > 0) {
				// Handle the selected files
				this.handleFiles(files);
			}
			if (cancelFunc) {
				await this.cancelUploadParser(false);
			}
		},
		handleDrop(event) {
			event.preventDefault();

			const files = event.dataTransfer.files;

			if (files.length > 0) {
				// Handle the dropped files
				this.handleFiles(files);
			}
		},

		handleDragOver(event) {
			event.preventDefault();
		},
		readFile(file) {
			const reader = new FileReader();
			reader.onload = () => {
				this.pdfPreview = reader.result;
			};
			reader.onerror = () => {
				console.error("Error reading the file.");
			};
			reader.readAsDataURL(file);
		},
		stopWatchingCandidateInfo() {
			// Unwatch the candidateInfoWatcher
			if (this.candidateInfoWatcher) {
				this.candidateInfoWatcher();
				this.candidateInfoWatcher = null; // Reset the watcher variable
			}
		},
		updateProgressBarBackground() {
			console.log("ok");
			let containerss;
			if (this.isLaptop) {
				containerss = this.$refs.progressContainer;
			} else {
				containerss = this.$refs.progressContainerMob;
			}
			const percentage = this.progressPercentage / 100;
			const rotation = percentage * 360;
			if (containerss) {
				containerss.style.background = `conic-gradient(white ${rotation}deg, transparent ${rotation}deg)`;
			}
		},
		//For cCancelling Upload
		async cancelUploadParser(uploadOpen = true) {
			try {
				const resp = await cancelUpload();

				if (resp.status == 200) {
					// this.getCandidateDetail();
					this.progressPercentage = 0;
					this.showTaskBarShimmer = true;
					if (this.showBackToOnboarding) {
						try {
							localStorage.setItem(
								"landing_onboarding_upload_flow_active",
								"upload"
							);
						} catch (e) {
							/* ignore */
						}
					}
					if (uploadOpen) {
						this.candidateInfoWatcher = this.$watch(
							"localCandidateInfo",
							this.chkFilledDetails
						);
					}
					// await this.getDynamicMandetoryFields();
					// await this.getCommonFuncForProfile();
					// this.setInitialLocalCandidateInfo();
					// this.setInitialAtsLocalCandidateInfo();
					// getUserCreditsData(this);
				} else {
					console.log("Api Error");
				}
			} catch (error) {
				console.log(error);
			}
		},
		async handleFiles(files) {
			let pdfcheck = files[0];
			let progress = 0;
			if (
				pdfcheck.type.includes("pdf") ||
				pdfcheck.type.includes("application/msword") ||
				pdfcheck.type.includes(
					"application/vnd.openxmlformats-officedocument.wordprocessingml.document"
				)
			) {
				const fileSizeInMb = pdfcheck.size / (1024 * 1024);
				if (fileSizeInMb > 5) {
					console.log("error file size");
					this.errorModal(
						"Upload Failed",
						"Please upload a file less than 5MB."
					);
					this.$refs.files?.reset();
				} else {
					this.showProgressBar = true;
					this.resumeForParser = files[0];
					// Simulate progress
					let timing = 100;
					const interval = setInterval(async () => {
						if (progress < 50) {
							progress += 2;
						} else if (progress < 85) {
							progress += 1;
						} else if (progress < 98) {
							Math.floor((progress += 0.1));
						} else if (progress == 100) {
							this.readFile(pdfcheck);
							// selectResume(event, this);
							this.stopWatchingCandidateInfo();
							this.openCreateButton = true;
							clearInterval(interval);
							this.showProgressBar = false;
						}

						this.progressPercentage = Math.floor(progress);
						this.updateProgressBarBackground();
					}, timing);
					let payload = {
						file: this.resumeForParser,
						builder: true,
						id: this.candidateInfo._id || this.getCandPrimaryInfo._id,
					};
					let form = new FormData();
					for (const key in payload) {
						form.append(key, payload[key]);
					}
					try {
						const resp = await postCandParser(form);
						if (resp.status === 200) {
							this.$emit("upload-parse-complete");
						}
						if (
							resp.status === 200 ||
							resp.status === 500 ||
							resp.status === 401 ||
							resp.status === 413
						) {
							progress = 100;
							// this.$emit("getCommonFuncForProfile");
						}
					} catch (error) {
						progress = 100;
						// this.$emit("getCommonFuncForProfile");
					}
				}
			} else {
				this.errorModal("Error", "Please upload a .pdf or .docx file");
			}
		},
	},
};
</script>

<style>
.hidden-file-input {
	opacity: 0;
	position: absolute;
	z-index: -1;
	width: 0;
	height: 0;
}
.mobile-upload-res {
	border-radius: 4px;
	border: 2px dashed #20639b;
	height: 70px;
	flex-shrink: 0;
	box-shadow: 0px 4px 8px 0px #0000002b;
}
.mobile-uploaded-res {
	border-radius: 4px;
	border: 2px solid #8c8c8c4d;
	height: 70px;
	flex-shrink: 0;
	box-shadow: 0px 4px 8px 0px #0000002b;
}

.mobile-upload-res .asp-small-grey-txt-2,
.mobile-uploaded-res .asp-small-grey-txt-2 {
	font-size: 16px;
}

.mobile-upload-res .mobjd-light-txt {
	font-size: 12px;
}

.mobile-upload-res .asp-vertical-line {
	width: 2px !important;
	height: 50px;
}
.upload-inline-back-btn {
	border-radius: 40px !important;
	background: #ffffff !important;
	color: #344054 !important;
	border: 1px solid #d0d5dd !important;
	padding: 6px 20px !important;
	font-family: "Montserrat", sans-serif;
	font-size: 13px !important;
	font-weight: 500 !important;
}
.mt-16px {
	margin-top: 16px;
}
.left-cont-padding {
	padding: 24px 0 0 24px;
}
.vertical-dashed {
	width: 2px;
	height: 100%;
	background: repeating-linear-gradient(
		to bottom,
		#d8d5d5,
		#d8d5d5 8px,
		transparent 8px,
		transparent 16px
	);
}
.w-152px {
	width: 152px !important;
}
.dragdrop-area {
	background: #ffffff;
	box-shadow: 0px 4.17891px 8.35783px rgba(0, 0, 0, 0.17);
	border-radius: 12px;
	position: relative;
}

.dragdrop-area::before {
	content: "";
	position: absolute;
	inset: 0;
	border-radius: 12px;
	padding: 2px;

	background:
    /* TOP */ repeating-linear-gradient(
				to right,
				#20639b 0 10px,
				transparent 10px 18px
			)
			top / 100% 2px no-repeat,
		/* BOTTOM */
			repeating-linear-gradient(to right, #20639b 0 10px, transparent 10px 18px)
			bottom / 100% 2px no-repeat,
		/* LEFT */
			repeating-linear-gradient(
				to bottom,
				#20639b 0 10px,
				transparent 10px 18px
			)
			left / 2px 100% no-repeat,
		/* RIGHT */
			repeating-linear-gradient(
				to bottom,
				#20639b 0 10px,
				transparent 10px 18px
			)
			right / 2px 100% no-repeat;

	pointer-events: none;
}
.mt-24px {
	margin-top: 24px;
}
.ortxt {
	font-style: italic;
	font-weight: 500;
	font-size: 14px;
	color: #828ba2;
	left: 40%;
	background-color: #ffffff;
	padding: 16px;
	top: -11px;
}
.padding24px {
	padding: 24px;
}
.after-upload-box {
	width: 288px;
	/* border: 2px solid #038e00; */
	border-radius: 8px;
	position: relative;
	overflow: hidden; /* IMPORTANT */
}

/* Background image */
.after-upload-box::before {
	content: "";
	position: absolute;
	inset: 0;
	background: url("../../assets/img/uploadresume/blurbg.png") center/cover
		no-repeat;
	z-index: 1;
}

/* Blur layer */
.after-upload-box::after {
	content: "";
	position: absolute;
	inset: 0;
	backdrop-filter: blur(6px);
	background: rgba(255, 255, 255, 0.4); /* glass effect */
	z-index: 2;
	border-radius: 8px;
}

/* Your content */
.after-upload-box > * {
	position: relative;
	z-index: 3;
}
.after-upload-box-footer {
	padding: 11px;
	background: #ffffff;
	border-top: 2px solid #038e00;
	box-shadow: 0px 4.17891px 8.35783px rgba(0, 0, 0, 0.17);
	/* border-radius: 0px 0px 12.5367px 12.5367px; */
}
.w-65 {
	width: 65% !important;
}
.circle-loader {
	position: relative;
	width: 160px;
	height: 160px;
}

.progress-ring {
	transform: rotate(-90deg);
}

/* Outer ring */
.outer-ring {
	fill: none;
	stroke: #20639b;
	stroke-width: 6;
	opacity: 0.25;
}

/* Dashed ring (always visible) */
.dashed-ring {
	fill: none;
	stroke: #20639b;
	stroke-width: 2;
	stroke-dasharray: 6 6;
	opacity: 0.8;
}

/* Progress arc */
.progress-ring-fill {
	fill: none;
	stroke: #20639b;
	stroke-width: 6;
	stroke-linecap: round;
	transition: stroke-dashoffset 0.4s ease;
}

/* Text */
.progress-text {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: 32px;
	font-weight: 700;
	color: #20639b;
}

@media (max-width: 1028px) {
	#draganddrop .modal-body {
		background: #f7f9fc;
		padding-bottom: env(safe-area-inset-bottom) !important;
	}
	#draganddrop .modal-dialog {
		margin: 0;
	}
	#draganddrop .modal {
		z-index: 2070;
	}
	#draganddrop .modal-content {
		top: 0px;
		height: 100dvh;
		overflow: auto;
		padding-top: env(safe-area-inset-top);
	}
	#draganddrop .mobile-header {
		z-index: unset;
	}
	.mobilecloseicon {
		position: absolute;
		top: 13px;
		right: 8px;
	}
	.mobflexcolumn {
		flex-direction: column;
	}
	.mob-w-100 {
		width: 100%;
	}
	.mobpx-0 {
		padding-left: 0;
		padding-right: 0;
	}
	.mobw50 {
		width: 50% !important;
	}
	.mobile-main-content-screen {
		height: calc(100dvh - 180px);
	}
	.mobile-exp-content-screen {
		height: calc(100dvh - 200px);
	}
	.mobile-step2-main {
		height: calc(100dvh - 180px);
	}
	.bottom-85 {
		bottom: 85px !important;
	}
	.mobile-upload-resume {
		position: absolute;
		bottom: 85px;
		left: 30%;
	}
	.mobflexwrap {
		flex-wrap: wrap;
	}
	.mobh-90 {
		height: 90%;
	}
	.mobd-flex {
		display: flex;
	}
	.mob-align-center {
		align-items: center;
	}
	.mob-justify-center {
		justify-content: center;
	}
	.mobmt8 {
		margin-top: 8px;
	}
	.dragdrop-area::before {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: 12px;
		padding: 2px;
		background:
    /* TOP */ repeating-linear-gradient(
					to right,
					#20639b 0 10px,
					transparent 10px 18px
				)
				top / 100% 2px no-repeat,
			/* BOTTOM */
				repeating-linear-gradient(
					to right,
					#20639b 0 10px,
					transparent 10px 18px
				)
				bottom / 100% 2px no-repeat,
			/* LEFT */
				repeating-linear-gradient(
					to bottom,
					#20639b 0px 10px,
					transparent 10px 18px
				)
				left / 2px 100% no-repeat,
			/* RIGHT */
				repeating-linear-gradient(
					to bottom,
					#20639b 0px 10px,
					transparent 10px 18px
				)
				right / 2px 100% no-repeat !important;

		pointer-events: none;
	}
	.mobile-upload-res {
		border: unset !important;
	}
	.circle-loader {
		position: relative;
		width: 200px;
		height: 200px;
	}
	.dragdrop-uploaded {
		border: 1px solid #038e00 !important;
		box-shadow: 0px 4.17891px 8.35783px rgba(0, 0, 0, 0.17);
		border-radius: 12.5367px;
	}
}
.after-upload-box.uploading-state {
	border: 2px solid #20639b;
}

.after-upload-box.uploaded-state {
	border: 2px solid #038e00;
}
.uploadingtxt {
	position: absolute;
	top: 245px;
	left: 35%;
	z-index: 4;
}
</style>
